module.exports = __webpack_public_path__ + "img/logo.e30e68e9.png";